/**
 * Client-side flag gates for the institutional (.edu/.org) sign-in + promotion
 * surfaces. While the env vars are absent — the deployed default — every
 * institutional surface renders NOTHING and makes no request, so the login,
 * settings, Share & Earn and admin UIs stay identical to today.
 *
 * The server enforces its own gates (qlearn.institutional.enabled and
 * qlearn.institutional.promotion-enabled, both false by default) and stays
 * authoritative; these flags are UX-only.
 *
 * Fail-closed: only the exact string "true" turns a surface on.
 */
export const isInstitutionalLoginEnabled = () =>
  process.env.REACT_APP_INSTITUTIONAL_LOGIN_ENABLED === "true";

export const isInstitutionalPromotionEnabled = () =>
  process.env.REACT_APP_INSTITUTIONAL_PROMOTION_ENABLED === "true";

/**
 * Email-code sign-in for ANY address (A2(a)): the same tab and endpoints, renamed
 * "Email Code", taking any well-formed address. Needs the institutional login flag too,
 * because that is what renders the tab. The server's own setting
 * (qlearn.institutional.any-address-enabled, false by default) stays authoritative.
 */
export const isEmailCodeAnyAddressEnabled = () =>
  isInstitutionalLoginEnabled() && process.env.REACT_APP_EMAIL_CODE_ANY_ADDRESS_ENABLED === "true";
